import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import { playGameJingle } from '../JingleController';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  constructor() {
    super({ key: Intro.KEY });
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._title_background, this).setOrigin(0);

    this.title = ABCyaPhaser.Images.addImage(width / 2 - 1000, height / 2 - 80, UIAssetKeys._title, this);
    switch (gameData.mode) {
      case 'hanukkah':
        this.title.y = height / 2 - 130;
        this.title.scale = 0.9;
        break;
    }
    ABCyaPhaser.Tweens.addTween(this.title, 2400, { x: this.title.x + 1000 }, Phaser.Math.Easing.Bounce.Out, () => this.accordionEffect(this.title));

    this.button = ABCyaPhaser.Buttons.addSimpleButton(width / 2, height / 2 + 205, UIAssetKeys._go_button, null, () => this.goClicked(), this).setScale(1.2);
    this.tweens.timeline({
      tweens:
                [
                  ABCyaPhaser.Tweens.createTween(this.button, 500, { delay: 100, scale: 1.7 }, Phaser.Math.Easing.Bounce.Out),
                  ABCyaPhaser.Tweens.createTween(this.button, 500, { scale: 1.2 }, Phaser.Math.Easing.Bounce.Out),
                ]
    });

    playGameJingle();

    this.time.addEvent({ delay: 1200, callback: this.bunnyAppears, callbackScope: this, repeat: -1 });
  }

  accordionEffect(sprite) {
    this.tweens.timeline({
      tweens:
                [
                  ABCyaPhaser.Tweens.createTween(sprite, 500, { angle: 5 }, Phaser.Math.Easing.Linear),
                  ABCyaPhaser.Tweens.createTween(sprite, 500, { angle: 0 }, Phaser.Math.Easing.Linear),
                  ABCyaPhaser.Tweens.createTween(sprite, 500, { angle: -5 }, Phaser.Math.Easing.Linear),
                  ABCyaPhaser.Tweens.createTween(sprite, 500, { angle: 0 }, Phaser.Math.Easing.Linear),
                ],
      loop: -1
    });

    this.tweens.timeline({
      tweens:
                [
                  ABCyaPhaser.Tweens.createTween(sprite, 900, { scaleX: 0.9 }, Phaser.Math.Easing.Linear),
                  ABCyaPhaser.Tweens.createTween(sprite, 1500, { scaleX: 1 }, Phaser.Math.Easing.Linear),
                ],
      loop: -1
    });
  }

  goClicked() {
    this.button.disableInteractive();

    this.doTransition();
  }

  doTransition() {
    this.tweens.add({ targets: this.cameras.main, duration: 400, props: { x: -1200 }, ease: Phaser.Math.Easing.Linear, onComplete: () => this.scene.start(Game.KEY) });
  }

  bunnyAppears() {
    const num = Phaser.Math.Between(0, 3);

    const bunny = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._bunny, this);

    switch (gameData.mode) {
      case 'halloween':
        bunny.setAlpha(0.7);
        break;
    }

    if (num === 0) {
      // bottom screen
      let offset = bunny.height;
      switch (gameData.mode) {
        case 'shamrock':
          offset -= 70;
          break;
      }
      const x = Phaser.Math.Between(100, this.scale.width - 100);
      const y = this.scale.height + offset;

      bunny.x = x;
      bunny.y = y;

      this.tweens.timeline({
        tweens:
                    [
                      ABCyaPhaser.Tweens.createTween(bunny, 300, { y: bunny.y - 1.5 * offset }, Phaser.Math.Easing.Linear),
                      ABCyaPhaser.Tweens.createTween(bunny, 900, { y: bunny.y, delay: 200 }, Phaser.Math.Easing.Linear, () => bunny.destroy()),
                    ]
      });
    }
    else if (num === 1) {
      // top
      bunny.angle = 180;

      const offset = bunny.height;
      const x = Phaser.Math.Between(100, this.scale.width - 100);
      const y = -offset;

      bunny.x = x;
      bunny.y = y;

      this.tweens.timeline({
        tweens:
                    [
                      ABCyaPhaser.Tweens.createTween(bunny, 300, { y: bunny.y + 1.5 * offset }, Phaser.Math.Easing.Linear),
                      ABCyaPhaser.Tweens.createTween(bunny, 900, { y: bunny.y, delay: 200 }, Phaser.Math.Easing.Linear, () => bunny.destroy()),
                    ]
      });
    }
    else if (num === 2) {
      // left
      bunny.angle = 90;

      const offset = bunny.height;
      const x = -offset;
      const y = Phaser.Math.Between(100, this.scale.height - 100);

      bunny.x = x;
      bunny.y = y;

      this.tweens.timeline({
        tweens:
                    [
                      ABCyaPhaser.Tweens.createTween(bunny, 300, { x: bunny.x + 1.5 * offset }, Phaser.Math.Easing.Linear),
                      ABCyaPhaser.Tweens.createTween(bunny, 900, { x: bunny.x, delay: 200 }, Phaser.Math.Easing.Linear, () => bunny.destroy()),
                    ]
      });
    }
    else if (num === 3) {
      // right
      bunny.angle = -90;

      const offset = bunny.height;
      const x = this.scale.width + offset;
      const y = Phaser.Math.Between(100, this.scale.height - 100);

      bunny.x = x;
      bunny.y = y;

      this.tweens.timeline({
        tweens:
                    [
                      ABCyaPhaser.Tweens.createTween(bunny, 300, { x: bunny.x - 1.5 * offset }, Phaser.Math.Easing.Linear),
                      ABCyaPhaser.Tweens.createTween(bunny, 900, { x: bunny.x, delay: 200 }, Phaser.Math.Easing.Linear, () => bunny.destroy()),
                    ]
      });
    }
  }
}